[
  {
    "id": "dawnmere_orc_attack",
    "day": 2,
    "locationId": "dawnmere",
    "conditions": [],
    "preventedByFlags": [],
    "effects": ["start_dawnmere_battle"],
    "grantsKnowledge": ["orcs_attack_dawnmere_day2"]
  },
  {
    "id": "goldenfields_orc_raid",
    "day": 15,
    "locationId": "goldenfields",
    "conditions": [],
    "preventedByFlags": ["goldenfields_raid_prevented"],
    "effects": ["start_goldenfields_battle"],
    "grantsKnowledge": ["orcs_raid_goldenfields_day12"]
  },
  {
    "id": "ironwatch_siege_begins",
    "day": 20,
    "locationId": "ironwatch_fortress",
    "conditions": [],
    "preventedByFlags": ["ironwatch_raid_prevented"],
    "effects": ["begin_ironwatch_siege"],
    "grantsKnowledge": ["orcs_besiege_ironwatch_day15"]
  },
  {
    "id": "ironwatch_siege_resolves",
    "day": 21,
    "locationId": "ironwatch_fortress",
    "conditions": [],
    "preventedByFlags": ["ironwatch_raid_prevented"],
    "effects": ["resolve_ironwatch_siege"]
  },
  {
    "id": "ironwatch_dragon_raid",
    "day": 33,
    "locationId": "ironwatch_fortress",
    "conditions": [],
    "preventedByFlags": [],
    "effects": ["start_ironwatch_dragon_raid"],
    "grantsKnowledge": ["dragon_raids_ironwatch_day22"]
  },
  {
    "id": "goldenfields_troll_incursion",
    "day": 37,
    "locationId": "goldenfields",
    "conditions": [],
    "preventedByFlags": [],
    "effects": ["start_goldenfields_troll_incursion"],
    "grantsKnowledge": ["trolls_raid_goldenfields_day26"]
  },
  {
    "id": "rivergate_night_raid",
    "day": 43,
    "locationId": "rivergate",
    "conditions": [],
    "preventedByFlags": [],
    "effects": ["start_rivergate_night_raid"],
    "grantsKnowledge": ["dark_elves_raid_rivergate_day33"]
  },
  {
    "id": "temple_anchor_rises",
    "day": 48,
    "locationId": "ruined_temple_first_dawn",
    "conditions": [],
    "preventedByFlags": [],
    "effects": ["start_temple_anchor_battle"],
    "grantsKnowledge": ["anchor_rises_at_temple_day38"]
  },
  {
    "id": "crossroads_giant_warband",
    "day": 55,
    "locationId": "kings_road_crossroads",
    "conditions": [],
    "preventedByFlags": [],
    "effects": ["start_crossroads_giant_warband"],
    "grantsKnowledge": ["giants_take_kings_road_day44"]
  },
  {
    "id": "blacktooth_rift_opens",
    "day": 67,
    "locationId": "blacktooth_wastes",
    "conditions": [],
    "preventedByFlags": [],
    "effects": ["start_blacktooth_rift_battle"],
    "grantsKnowledge": ["rift_opens_at_blacktooth_day50"]
  },
  {
    "id": "ritual_darkening_first",
    "day": 128,
    "locationId": "ebon_citadel",
    "conditions": [],
    "preventedByFlags": ["necromancer_defeated"],
    "effects": ["ritual_darkening_first"],
    "grantsKnowledge": ["saw_ritual_darkening"]
  },
  {
    "id": "ritual_darkening_second",
    "day": 256,
    "locationId": "ebon_citadel",
    "conditions": [],
    "preventedByFlags": ["necromancer_defeated"],
    "effects": ["ritual_darkening_second"],
    "grantsKnowledge": ["ritual_deepens_day240"]
  },
  {
    "id": "ritual_darkening_third",
    "day": 384,
    "locationId": "ebon_citadel",
    "conditions": [],
    "preventedByFlags": ["necromancer_defeated"],
    "effects": ["ritual_darkening_third"],
    "grantsKnowledge": ["ritual_deepens_day400"]
  },
  {
    "id": "ritual_deadline",
    "day": 512,
    "locationId": "ebon_citadel",
    "conditions": [],
    "preventedByFlags": ["necromancer_defeated"],
    "effects": ["ritual_extinguishes_sun"],
    "grantsKnowledge": ["saw_the_sun_go_out"]
  }
]
